<template>
  <!-- <el-dialog
    title="已关联证据"
    :visible.sync="dialogVisibleReport"
    :append-to-body="true"
    width="1000px"
    :before-close="handleClose"
    class="dialog_diy"
  > -->
  <div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      v-loading="isLoading"
      header-align="center"
      :header-cell-style="{
        background: '#E0EAFB',
        color: 'rgba(0, 0, 0, 0.90)'
      }"
    >
      <!-- <el-table-column type="selection" align="center" label="全选" width="55">
      </el-table-column> -->
      <el-table-column
        prop="create_at"
        label="创建时间"
        align="center"
        width="120"
      >
        <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
      </el-table-column>
      <el-table-column
        prop="recordTit"
        label="观察内容"
        align="center"
        width="140"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="place"
        label="观察地点"
        align="center"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="tname"
        label="维度"
        align="center"
        width="180"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="recordContent"
        label="内容"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @current-change="handleCurrentChange"
      background
      :page-size="10"
      layout="prev, pager, next"
      :total="total"
      class="pagination"
    >
    </el-pagination>
  </div>

  <!-- </el-dialog> -->
</template>

<script>
export default {
  props: {
    dialogVisibleReport: {
      type: Boolean,
      default: false
    },
    userid: {
      type: String
    },
    fid: {
      type: String
    },
    tid: {
      type: String
    },
    oid: {
      type: String
    },
    year: {
      type: String
    },
    cid: {
      type: String
    }
  },
  data() {
    return {
      // 表格数据
      tableData: [],
      // 总条数
      total: 0,
      // 当前页
      page: 1,
      isLoading: true
    };
  },
  watch: {
    // tid(newVal) {
    //   if (newVal) {
    //     this.getData();
    //   }
    // }
  },
  methods: {
    // 获取数据
    getData() {
      // console.log(8888888888);
      this.isLoading = true;
      this.tableData = [];
      // 获取筛选框数据
      let params = {
        uid: this.userid,
        cid: this.cid,
        cu: this.fid,
        cn: this.tid,
        cm: this.year,
        page: this.page
      };
      // console.log('// 获取数据', params);
      this.ajax
        .get(this.$store.state.api + "selectVeidooType", params)
        .then(res => {
          // console.log(" 获取筛选数据", res);
          this.total = res.data[0].length > 0 ? res.data[0][0].num : 0;
          this.isLoading = false;
          this.tableData = res.data[0];
        })
        .catch(err => {
          this.isLoading = false;
          console.error(err);
        });
    },
    // 切换页
    handleCurrentChange(val) {
      //当页数发生改变的时候调用获取列表数据请求
      // console.log(`当前页: ${val}`);
      this.page = val;
      this.getData();
    }
  },
  mounted() {
    // this.getData();
  }
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kindStudentEva/test/reportDialog/index.vue